import { Box, IconButton, Tooltip } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import { useTranslation } from "react-i18next";
type VotingProps = {
  onLike: any;
  onDislike: any;
  flexDirection: "column" | "row";
};

export function VotingComponent(props: VotingProps) {
  const { t } = useTranslation(["common"]);
  return (
    <Box flexDirection={props.flexDirection} display={"flex"}>
      <Tooltip title={t("common:correct_result").toString()}>
        <IconButton onClick={props.onLike} color="info">
          <ThumbUpOffAltIcon></ThumbUpOffAltIcon>
        </IconButton>
      </Tooltip>
      <Tooltip title={t("common:incorrect_result").toString()}>
        <IconButton onClick={props.onDislike} color="error">
          <ThumbDownOffAltIcon></ThumbDownOffAltIcon>
        </IconButton>
      </Tooltip>
    </Box>
  );
}
